import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import "./map.styl";
const template = require("./map.vue");

@Component({
  template: template
})
export default class MapComponent extends Vue {

  @Prop()
  latitude: number;
  @Prop()
  longitude: number;
  @Prop( { default: 15 })
  zoom: number;
  center = { lat: this.latitude, lng: this.longitude };
  markers = [{ position: this.center }];

  shouldLoadMap: boolean = false;

  created() {
    this.shouldLoadMap = this.latitude != null && this.longitude != null && this.latitude !== 0 && this.longitude !== 0 ;

  }
}

Vue.component("cmMap", MapComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/map/map.ts